import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { DfeLegacyImportEntry } from '@/lib/api';

interface ImportHistoryListProps {
  imports: DfeLegacyImportEntry[];
  loading: boolean;
  onRetry?: (entry: DfeLegacyImportEntry) => void;
}

export function ImportHistoryList({ imports, loading, onRetry }: ImportHistoryListProps) {
  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Import History</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
          </div>
        </CardContent>
      </Card>
    );
  }

  if (imports.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Import History</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Server</TableHead>
              <TableHead>Username</TableHead>
              <TableHead>Imported</TableHead>
              <TableHead>Skipped</TableHead>
              <TableHead>Status</TableHead>
              <TableHead></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {imports.map((imp) => (
              <TableRow key={imp.importId}>
                <TableCell className="text-sm">
                  {new Date(imp.createdAt).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  <Badge variant="outline">{imp.legacyServer}</Badge>
                </TableCell>
                <TableCell className="font-mono text-sm">{imp.legacyUsername}</TableCell>
                <TableCell>{imp.itemsImported}</TableCell>
                <TableCell>{imp.itemsSkipped}</TableCell>
                <TableCell>
                  <Badge variant={imp.importStatus === 'completed' ? 'default' : 'destructive'}>
                    {imp.importStatus}
                  </Badge>
                </TableCell>
                <TableCell>
                  {imp.importStatus === 'completed' && imp.itemsSkipped > 0 && onRetry && (
                    <Button variant="outline" size="sm" onClick={() => onRetry(imp)}>
                      Retry
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
